import { render, staticRenderFns } from "./PasswordResetConfirm.vue?vue&type=template&id=fc4f5adc&scoped=true"
import script from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirm.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetConfirm.vue?vue&type=style&index=0&id=fc4f5adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4f5adc",
  null
  
)

export default component.exports